import { Box, Grid, Typography, Tooltip, IconButton, InputAdornment } from "@mui/material";
import Button from "../../common/Button";
import PageBackButton from "../../common/PageBackButton";
import CustomTextField from "../../common/CustomTextField";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import {
  CancelOutlined,
  CheckCircleOutline,
  ClassOutlined,
  ErrorOutline,
  Inventory2Outlined,
  PersonOutlined,
  WarningAmberOutlined,
} from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import CustomDropdownField from "../../common/CustomDropdownFiled";
import CustomDatePicker from "../../common/CustomDatePicker";
import { SingleAlertInfo, setSingleAlertObj, showHideTrackingLoadingDialog } from "../../../redux/slice/commonSlice";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import { ReactNode, useEffect, useMemo, useRef, useState } from "react";
import { OrderFulfillmentInfo, OrderInfo, OrderItemDTO, TrackingRegistrationRequest, getOrderItemsByOrderId, getRealTimeTrackInfo, initialValuesOfOrderFulfillment, registerWebhookTracking, updateOrder, useOrderSlice, verifyOrderTrackingLogs } from "../../../redux/slice/order/OrderSlice";
import { CodeTable, fetchAllCodeTablesValues, getCodeTableValuesByTableName, useCodetablesSlice } from "../../../redux/slice/codetableSlice";
import dayjs from "dayjs";
import { PRODUCT_CATEGORY, PRODUCT_STATUS, RESPONSE_CODES } from "../../../constants/applicationConstants";
import OptionsPopup, { OptionPopupObjectProps } from "../../common/OptionsPopup";
import { getPatient } from "../../../redux/slice/patient/patientSlice";
import { useNavigation } from "../../../hooks/useNavigation";
import moment from "moment";
import { useAuthSlice } from "../../../redux/slice/authSlice";
import { fetchShippingMethodsForFulfillment, useProductListReducer } from "../../../redux/slice/product/productListSlice";
import TrackingWarningPopup from "../../common/TrackingWarningPopup";
import CustomCurrencyField from "../../common/CustomCurrencyField";
import ShippingMethodChangePopup from "./ShippingMethodChangePopup";
import { getInvoiceById } from "../../../redux/slice/invoice/InvoiceSlice";
import { fetchPracticeById, usePracticeSlice } from "../../../redux/slice/practiceSlice";
import {
  extractShippingCharge,
  findShippingMethodOption,
  formatShippingMethodWithCharge,
  FulfillmentInvoiceContext,
  getFulfillmentShippingBlockMessage,
  getPaidInvoiceChargeMismatchMessage,
  initialFulfillmentInvoiceContext,
  isPaidInvoiceStatus,
  isPaidInvoiceConfirmBlocked,
  isSameShippingMethodSelection,
  PAID_INVOICE_CHARGE_MISMATCH_MESSAGE,
  parseShippingChargeValue,
  resolveCurrentFulfillmentShippingInfo,
  resolveInvoiceIdFromOrder,
  resolveInvoiceStatusDisplay,
  resolveOriginalRequestedShippingInfo,
  resolvePreviousShippingCharge,
  resolvePreviousShippingChargeForFulfillment,
  resolveFulfillmentShippingDisplay,
  resolveRequestedShippingInfo,
  shippingChargesEqual,
  shouldUpdateInvoiceShipping,
} from "./shippingMethodUtils";
import { SectionHeader } from "../../ui/ContentSection";
import { useModalStyles } from "../../common/useModalStyles";
import {
  extractCarrierFromShippingMethod,
  getTrackingNumberFormatFeedback,
  validateTrackingNumberForShippingMethod,
} from "./trackingNumberUtils";

var statuses: CodeTable[] = [];

const OrderFulfillment = () => {
  var orderDetail: OrderInfo = {
    orderId: 0,
    practiceId: 0,
    productId: 0,
    ivrId: 0,
    patientId: 0,
    practiceName: "",
    hasMiddleName: false,
    patientName: "",
    productName: "",
    manufacturerName: "",
    manufacturerId: 0,
    providerName: "",
    orderNumber: "",
    orderDate: "",
    orderType: "",
    orderStatus: "",
    mfgConfirmationNumber: "",
    shippedDate: "",
    deliveredDate: "",
    processedDate: "",
    shippingCarrier: "",
    trackingNumber: "",
    poNumber: "",
    orderTotalUnit: 0,
    orderTotalPrice: 0,
    orderDocumentId: 0,
    orderItems: [] as OrderItemDTO[],
    manufacturerOrderId: "",
    manufacturerPatientId: "",
    requestedShippingMethod : "",
  };


  const { navigate } = useNavigation();
  const location = useLocation();
  const {
    tokens: mTokens,
    isDark: isDarkModal,
    datepickerWrapSx,
    dropdownWrapSx,
    inputFieldSx,
    primaryBtnSx,
    cancelBtnSx,
  } = useModalStyles();
  const cardSx = {
    borderRadius: "16px",
    border: `1px solid ${mTokens.border}`,
    backgroundColor: mTokens.bg,
    backgroundImage: "none",
    overflow: "hidden",
    boxShadow: isDarkModal ? "0 10px 20px rgba(0,0,0,0.1)" : "none",
  };
  const dispatch = useAppDispatch();

  const { control, handleSubmit, reset, watch, getValues, setError,
    setValue, clearErrors, trigger, formState: { errors } } = useForm<OrderFulfillmentInfo>({ defaultValues: initialValuesOfOrderFulfillment });

  const { fields, append, remove } = useFieldArray({ name: "orderItems", control });

  const { allCodeTablesValuesMap, allCodeTableValueFetchStatus } = useCodetablesSlice();
  const { orderItemsListInfo } = useOrderSlice();
  const [localOrderDetail, setLocalOrderDetail] = useState(orderDetail);
  const [isEditing, setIsEditing] = useState(false); 
  const [isAncillary, serIsAncillary] = useState(false); 
  const [mfrPatientId, setMFRPatientId] = useState<any>({
    patientId: orderDetail.patientId,
    manufacturerPatientId: getValues("manufacturerPatientId")
  });
  const [showUpdateMFRPatientIdPopup, setShowUpdateMFRPatientIdPopup] = useState<OptionPopupObjectProps>({ message: '', show: false });
  const [mfrPatientIDinPatientInfo, setMFRPatientIDinPatientInfo] = useState<string>("");
  const [orderNumber, setOrderNumber] = useState<string>("");
  const { userInfo } = useAuthSlice();
  // CS-1766 - Fulfillment lists every active shipping method
  const { shippingMethodsForFulfillment } = useProductListReducer();
  const { PracticeSaveInfo } = usePracticeSlice();
  // CS-1766 - Track original shipping method for change warning
  const [originalShippingMethod, setOriginalShippingMethod] = useState<string>("");
  const [originalShippingCharge, setOriginalShippingCharge] = useState<number>(0);
  const appliedShippingRef = useRef({ method: "", charge: 0 });
  const syncAppliedShipping = (method: string, charge: number) => {
    appliedShippingRef.current = { method, charge };
  };
  const [showShippingChangePopup, setShowShippingChangePopup] = useState(false);
  const [shippingChangePopupData, setShippingChangePopupData] = useState<{
    requestedShippingMethod: string;
    requestedShippingCharge: number;
    currentShippingMethod: string;
    currentShippingCharge: number;
    fulfillmentShippingMethod: string;
    initialFulfillmentCharge: number;
    previousShippingCharge: number;
    invoiceStatusLabel: string;
    invoiceStatusCategory: ReturnType<typeof resolveInvoiceStatusDisplay>["category"];
    invoiceStatus: string | null;
  } | null>(null);
  const [fulfillmentInvoice, setFulfillmentInvoice] = useState<FulfillmentInvoiceContext>(
    initialFulfillmentInvoiceContext
  );
  const [fullFillOrderWarningPopup, setFullFillOrderWarningPopup] = useState<{
    show: boolean;
    orderIds: string[];
    formData: OrderFulfillmentInfo | null;
  }>({ show: false, orderIds: [], formData: null });

  const trackingNumberValue = useWatch({
    control,
    name: "trackingNumber",
  });

  const selectedOrderDetail = location?.state?.selectedOrderDetail as OrderInfo | undefined;
  const practiceId = selectedOrderDetail?.practiceId;

  useEffect(() => {
    if (!practiceId) return;
    dispatch(fetchPracticeById(String(practiceId)));
  }, [practiceId, dispatch]);

  const allowFreeShipping = useMemo(() => {
    if (!practiceId || !PracticeSaveInfo) return false;
    if (String(PracticeSaveInfo.practiceId) !== String(practiceId)) return false;
    return PracticeSaveInfo.allowFreeShipping === true;
  }, [practiceId, PracticeSaveInfo]);

  const isManualOutsideShipping = useMemo(() => {
    const detail = localOrderDetail?.orderId ? localOrderDetail : selectedOrderDetail;
    const orderInfo = detail?.orderInfo;
    const isOutsideOrder = detail?.isOutsideOrder === true || orderInfo?.isOutsideOrder === true || orderInfo?.isOutsideOrder === "true";
    return Boolean(isOutsideOrder && orderInfo?.shippingAddressEntryType === "MANUAL");
  }, [localOrderDetail, selectedOrderDetail]);

   const orderStatusValue = useWatch({
      control,
      name: "orderStatus",
    });
  
    const previousOrderStatusRef = useRef<string | undefined>(undefined);
  
    const getDateLabelForStatus = (status?: string) => {
      if (!status) return "Date";
      const matchedStatus = statuses.find((option) => option.keyName === status);
      return matchedStatus?.displayValue
        ? `${matchedStatus.displayValue} Date`
        : "Date";
    };
  
    const hasUpdateStatusDateValue = (value: unknown) => {
      if (value == null) return false;
      if (dayjs.isDayjs(value)) return value.isValid();
      const str = String(value).trim();
      if (!str) return false;
      return dayjs(str, "MM/DD/YYYY", true).isValid() || dayjs(str).isValid();
    };
  
    const updateStatusDateLabelText = useMemo(
      () => getDateLabelForStatus(orderStatusValue),
      [orderStatusValue, allCodeTablesValuesMap]
    );
  
    const updateStatusDateRules = useMemo(() => {
      const dateLabel = getDateLabelForStatus(orderStatusValue);
      return {
        required: `${dateLabel} is required.`,
        validate: (value: unknown) => {
          const currentLabel = getDateLabelForStatus(getValues("orderStatus"));
          return hasUpdateStatusDateValue(value) || `${currentLabel} is required.`;
        },
      };
    }, [orderStatusValue, allCodeTablesValuesMap, getValues]);
  
    // Re-validate only when the user changes status (not on initial prefilled load)
    useEffect(() => {
      const previousStatus = previousOrderStatusRef.current;
      previousOrderStatusRef.current = orderStatusValue;
  
      if (previousStatus === undefined) {
        clearErrors("updateStatusDate");
        return;
      }
  
      if (previousStatus === orderStatusValue) {
        return;
      }
  
      clearErrors("updateStatusDate");
      void trigger("updateStatusDate");
    }, [orderStatusValue, updateStatusDateLabelText, clearErrors, trigger]);
  

  //mount
  useEffect(() => {
    orderDetail = location?.state?.selectedOrderDetail;
    setLocalOrderDetail(orderDetail)
    if(orderDetail.productCategory === PRODUCT_CATEGORY.CONSERVATIVE) {
      serIsAncillary(true);
    }
    if (!orderDetail.manufacturerOrderId) {
      orderDetail.manufacturerOrderId = ""; 
    }
    reset(orderDetail);
    if(orderDetail.orderStatus === PRODUCT_STATUS.SHIPPED){
      setValue("updateStatusDate", orderDetail.shippedDate);
    } else if (orderDetail.orderStatus === PRODUCT_STATUS.PROCESSING){
      setValue("updateStatusDate", orderDetail.orderInfo?.processedDate || "");
    } else if (orderDetail.orderStatus === PRODUCT_STATUS.DELIVERED){
      setValue("updateStatusDate", orderDetail.deliveredDate)
    } else {
      setValue("updateStatusDate", dayjs().format('MM/DD/YYYY'));
    }
    const isOutsideOrder =
      orderDetail.isOutsideOrder === true ||
      orderDetail.orderInfo?.isOutsideOrder === true ||
      orderDetail.orderInfo?.isOutsideOrder === "true";
    if (isOutsideOrder && orderDetail.orderInfo?.shippingAddressEntryType === "MANUAL") {
      const manualShippingMethod = orderDetail.orderInfo?.shippingMethod || orderDetail.requestedShippingMethod || "";
      const manualShippingPrice = orderDetail.orderInfo?.shippingPrice ?? orderDetail.outsideOrderShippingPrice ?? "";
      setValue("shippingMethod", manualShippingMethod);
      setValue("shippingMethodId", null);
      setValue("shippingPrice", manualShippingPrice);
      setOriginalShippingMethod(manualShippingMethod);
      const manualCharge =
        Number(manualShippingPrice) ||
        extractShippingCharge(manualShippingMethod) ||
        resolvePreviousShippingCharge(orderDetail);
      setOriginalShippingCharge(manualCharge);
      syncAppliedShipping(manualShippingMethod, manualCharge);
    } else {
      const requestedShipping = resolveRequestedShippingInfo(orderDetail);
      setOriginalShippingCharge(resolvePreviousShippingCharge(orderDetail) || requestedShipping.charge);
    }
    if(orderDetail.orderStatus === PRODUCT_STATUS.PLACED) {
    setValue("orderStatus", "");
    }
    clearErrors("updateStatusDate");
    dispatch(getOrderItemsByOrderId(orderDetail.orderId));
    setOrderNumber(orderDetail.orderNumber);

    const fetchPatientDetails = async () => {
      try {
        const response = await dispatch(getPatient({ patientId: orderDetail.patientId.toString() })).unwrap();
        const updateOrderInfo = response.data.patientInfo?.find((info: { infoType: string; }) => info.infoType === "MANUFACTURER_PATIENT_IDS");
        
        if (updateOrderInfo && updateOrderInfo.patientinfoData) {
          const manufacturerId = orderDetail.manufacturerId;
        
          const manufacturerEntries = Object.values(updateOrderInfo.patientinfoData) as {
            manufacturerId: number;
            manufacturerPatientId: string;
          }[];
        
          const manufacturerEntry = manufacturerEntries.find(
            (entry) => entry.manufacturerId === manufacturerId
          );
        
          if (manufacturerEntry) {
            setValue("manufacturerPatientId", manufacturerEntry.manufacturerPatientId);
            orderDetail.manufacturerPatientId = manufacturerEntry.manufacturerPatientId;
            setMFRPatientIDinPatientInfo(manufacturerEntry.manufacturerPatientId);
          }
  
          if (getValues("manufacturerPatientId")) {
            setIsEditing(false);
          } else {
            setIsEditing(true);

          }
        }
  
      } catch (error) {
        console.error("Error fetching patient details:", error);
      }
    };
  
    fetchPatientDetails();
  }, []);

  // unmount
  useEffect(() => () => { }, []);

  // CS-1766 - Fetch product shipping config when order has a productId
  // CS-1997 - Pass the practice so the backend zeroes shipping rates for free-shipping practices.
  // CS-1766 - Fulfillment asks for every active method, so a method that is disabled for the product,
  // or outside the free-shipping code table, can still be used to ship the order.
  useEffect(() => {
    const productId = location?.state?.selectedOrderDetail?.productId;
    const practiceId = location?.state?.selectedOrderDetail?.practiceId;
    if (productId) {
      dispatch(fetchShippingMethodsForFulfillment({
        productId: Number(productId),
        practiceId: practiceId ? Number(practiceId) : undefined,
      }));
    }
  }, [location?.state?.selectedOrderDetail?.productId, location?.state?.selectedOrderDetail?.practiceId, dispatch]);

  // CS-1766 - Build shipping method options from product shipping config API
  const shippingMethodOptions = useMemo(() => {
    if (!shippingMethodsForFulfillment || shippingMethodsForFulfillment.length === 0) return [];
    return shippingMethodsForFulfillment.map((config: any) => {
      const rate = config.rate ?? 0;
      const label = rate >= 0
        ? `${config.carrier} - ${config.name} ($${Number(rate).toFixed(2)})`
        : `${config.carrier} - ${config.name}`;
      return {
        label,
        value: label,
        shippingConfigId: config.shippingConfigId, // CS-1758 - Carry ID for lookup
      };
    });
  }, [shippingMethodsForFulfillment]);

  const shippingMethodValue = useWatch({ control, name: "shippingMethod" });
  const shippingPriceValue = useWatch({ control, name: "shippingPrice" });

  const trackingFormatFeedback = useMemo(
    () => getTrackingNumberFormatFeedback(trackingNumberValue, shippingMethodValue),
    [trackingNumberValue, shippingMethodValue]
  );

  const trackingNumberRules = useMemo(
    () => ({
      validate: (value: string) =>
        validateTrackingNumberForShippingMethod(value, getValues("shippingMethod")),
    }),
    [shippingMethodValue, getValues]
  );

  useEffect(() => {
    const currentTrackingNumber = getValues("trackingNumber");
    if (!currentTrackingNumber) {
      clearErrors("trackingNumber");
      return;
    }
    void trigger("trackingNumber");
  }, [shippingMethodValue, getValues, clearErrors, trigger]);

  const trackingFieldWrapSx = useMemo(() => {
    const base = inputFieldSx();
    if (trackingFormatFeedback.status === "idle") return base;
    const color = trackingFormatFeedback.status === "valid" ? "#22c55e" : mTokens.error;
    return {
      ...base,
      "& .MuiOutlinedInput-root fieldset, & .MuiOutlinedInput-notchedOutline": {
        borderColor: `${color} !important`,
      },
      "& .MuiOutlinedInput-root:hover fieldset": {
        borderColor: `${color} !important`,
      },
      "& .MuiOutlinedInput-root.Mui-focused fieldset": {
        borderColor: `${color} !important`,
        borderWidth: "1px !important",
      },
      "& .MuiOutlinedInput-root.Mui-focused": {
        boxShadow: isDarkModal ? "none" : `0 0 0 3px ${color}33`,
      },
      "& .MuiFormHelperText-root": {
        color: `${color} !important`,
        marginLeft: "2px",
        fontWeight: 600,
      },
    };
  }, [inputFieldSx, trackingFormatFeedback.status, isDarkModal, mTokens.error]);

  const fulfillmentShippingMethodOptions = useMemo(() => {
    if (!shippingMethodValue || shippingMethodOptions.length === 0) {
      return shippingMethodOptions;
    }

    const matchedOption = findShippingMethodOption(shippingMethodOptions, shippingMethodValue);
    if (!matchedOption) {
      return shippingMethodOptions;
    }

    const customCharge = parseShippingChargeValue(shippingPriceValue);
    const optionCharge = extractShippingCharge(matchedOption.value);
    const valueCharge = extractShippingCharge(shippingMethodValue);
    const chargeToDisplay = customCharge ?? valueCharge ?? optionCharge;

    if (chargeToDisplay == null) {
      return shippingMethodOptions;
    }

    if (
      optionCharge != null
      && shippingChargesEqual(chargeToDisplay, optionCharge)
      && shippingMethodValue === matchedOption.value
    ) {
      return shippingMethodOptions;
    }

    const displayValue = formatShippingMethodWithCharge(matchedOption.value, chargeToDisplay);
    return shippingMethodOptions.map((opt) =>
      opt.value === matchedOption.value
        ? { ...opt, label: displayValue, value: displayValue }
        : opt
    );
  }, [shippingMethodOptions, shippingMethodValue, shippingPriceValue]);

  // CS-1766 - Resolve shippingMethodId when shipping config loads and pre-fill method
  useEffect(() => {
    if (isManualOutsideShipping) return;
    if (shippingMethodOptions.length === 0) return;
    const orderDetail = location?.state?.selectedOrderDetail;
    const configId = orderDetail?.orderInfo?.shippingMethodId ?? orderDetail?.orderInfo?.requestedShippingConfigId;
    if (configId) {
      const matched = shippingMethodOptions.find((opt: any) => opt.shippingConfigId === Number(configId));
      if (matched) {
        const { displayMethod, displayCharge } = resolveFulfillmentShippingDisplay(
          orderDetail,
          matched
        );
        setValue("shippingMethod", displayMethod);
        setValue("shippingMethodId", matched.shippingConfigId);
        setValue("shippingPrice", displayCharge);
        setOriginalShippingMethod(displayMethod);
        setOriginalShippingCharge(
          resolvePreviousShippingCharge(orderDetail) ?? displayCharge
        );
        syncAppliedShipping(displayMethod, displayCharge);
      }
    }
  }, [isManualOutsideShipping, shippingMethodOptions, location?.state?.selectedOrderDetail, setValue]);

  useEffect(() => {
    if (orderItemsListInfo) {
      const sortedOrderItems = [...orderItemsListInfo].sort((a, b) => a.units - b.units);
      setValue("orderItems", sortedOrderItems);
    }
  }, [orderItemsListInfo]);

  useEffect(() => {
    const orderDetailData = location?.state?.selectedOrderDetail as OrderInfo | undefined;
    const invoiceId = resolveInvoiceIdFromOrder(orderDetailData, orderItemsListInfo ?? undefined);

    if (!invoiceId) {
      setFulfillmentInvoice({
        invoiceId: null,
        invoiceStatus: null,
        shippingCharges: null,
        loaded: true,
      });
      return;
    }

    let cancelled = false;

    const loadInvoiceStatus = async () => {
      setFulfillmentInvoice((prev) => ({ ...prev, invoiceId, loaded: false }));

      try {
        const response = await dispatch(
          getInvoiceById({ invoiceId, isSaveAuditLog: false, skipLoader: true })
        );

        if (cancelled) return;

        if (response?.payload?.code === RESPONSE_CODES.SUCCESS_CODE && response?.payload?.data) {
          const invoice = response.payload.data;
          setFulfillmentInvoice({
            invoiceId,
            invoiceStatus: invoice.invoiceStatus ?? null,
            shippingCharges: invoice.shippingCharges ?? null,
            loaded: true,
          });
          return;
        }
      } catch (error) {
        console.error("Error fetching invoice status for fulfillment:", error);
      }

      if (!cancelled) {
        setFulfillmentInvoice({
          invoiceId,
          invoiceStatus: null,
          shippingCharges: null,
          loaded: true,
        });
      }
    };

    void loadInvoiceStatus();

    return () => {
      cancelled = true;
    };
  }, [location?.state?.selectedOrderDetail?.orderId, orderItemsListInfo, dispatch]);

  useEffect(() => {
    if (!fulfillmentInvoice.loaded) return;
    const orderDetailData = location?.state?.selectedOrderDetail as OrderInfo | undefined;
    const charge = resolvePreviousShippingChargeForFulfillment(orderDetailData, fulfillmentInvoice);
    setOriginalShippingCharge(charge);
  }, [fulfillmentInvoice, location?.state?.selectedOrderDetail]);

  // CS-1766 - Commented out: carrierOptions no longer needed, shipping methods fetched from product-specific API
  // const carrierOptions = useMemo(() => {
  //   let carriers: CodeTable[] = [];
  //   if (allCodeTablesValuesMap) {
  //     carriers = getCodeTableValuesByTableName(allCodeTablesValuesMap, "Carrier");
  //   }
  //   if (!carriers || carriers.length === 0) {
  //     dispatch(fetchAllCodeTablesValues());
  //   }
  //   let options: { label: string, value: any }[] = [];
  //   carriers?.map((option) => {
  //     options.push({ label: option.displayValue, value: option.displayValue });
  //   });
  //   return options;
  // }, [allCodeTablesValuesMap]);

  const updateStatuses = useMemo(() => {
    if (allCodeTablesValuesMap) {
      statuses = getCodeTableValuesByTableName(allCodeTablesValuesMap, "UpdateOrderStatus");
    }
    if (!statuses || statuses.length === 0) {
      dispatch(fetchAllCodeTablesValues());
    }
    let options: { label: string, value: any }[] = [];
    statuses?.map((option) => {
      options.push({ label: option.displayValue, value: option.keyName });
      // if (getValues("orderStatus") === option.keyName) {
      //   setUpdateStatusLabel(option.displayValue);
      // }
    });
    return options;
  }, [allCodeTablesValuesMap]);

  const onSubmit = async (data: OrderFulfillmentInfo) => {
    orderDetail = location?.state?.selectedOrderDetail;

    const currentTrackingNumber = getValues("trackingNumber");
    // CS-1766 - Use shippingMethod instead of shippingCarrier for change detection
    const currentShippingMethod = getValues("shippingMethod");
    const previousTrackingNumber = orderDetail?.trackingNumber;
    const previousShippingMethod = originalShippingMethod;

    // If tracking number is new or changed, verify BEFORE calling updateOrder
    if (
      currentTrackingNumber &&
      (currentTrackingNumber !== previousTrackingNumber ||
        currentShippingMethod !== previousShippingMethod)
    ) {
      const verifyResponse = await dispatch(
        verifyOrderTrackingLogs({ trackingNumber: currentTrackingNumber })
      );

      if (verifyResponse.payload && verifyResponse.payload.length > 0) {
        setFullFillOrderWarningPopup({
          show: true,
          orderIds: verifyResponse.payload,
          formData: data,
        });
        return;
      }
    }

    await executeUpdateOrder(data);
  };

  const buildFulfillmentShippingPrice = (data: OrderFulfillmentInfo): string => {
    if (data.shippingPrice != null && data.shippingPrice !== "") {
      return String(data.shippingPrice);
    }
    const extracted = extractShippingCharge(data.shippingMethod);
    return extracted != null ? String(extracted) : "";
  };

  const hasFulfillmentShippingChanged = (data: OrderFulfillmentInfo): boolean => {
    const fulfillmentShippingPrice = buildFulfillmentShippingPrice(data);
    const orderDetailData = location?.state?.selectedOrderDetail as OrderInfo | undefined;
    const previousCharge = resolvePreviousShippingChargeForFulfillment(orderDetailData, fulfillmentInvoice);

    return data.shippingMethod !== originalShippingMethod
      || (fulfillmentShippingPrice !== "" && Number(fulfillmentShippingPrice) !== previousCharge);
  };

  const showFulfillmentShippingBlockAlert = (message: string) => {
    dispatch(setSingleAlertObj({ message, alertType: "error" }));
  };

  const executeUpdateOrder = async (data: OrderFulfillmentInfo) => {
    const shippingChanged = hasFulfillmentShippingChanged(data);
    const blockMessage = getFulfillmentShippingBlockMessage(fulfillmentInvoice, shippingChanged);
    if (blockMessage) {
      showFulfillmentShippingBlockAlert(blockMessage);
      return;
    }

    orderDetail = location?.state?.selectedOrderDetail;
    const fulfillmentShippingPrice = buildFulfillmentShippingPrice(data);
    const previousCharge = resolvePreviousShippingChargeForFulfillment(orderDetail, fulfillmentInvoice);
    const currentCharge = fulfillmentShippingPrice !== "" ? Number(fulfillmentShippingPrice) : previousCharge;
    const paidChargeMismatchMessage = getPaidInvoiceChargeMismatchMessage(
      fulfillmentInvoice,
      currentCharge,
      previousCharge,
      shippingChanged
    );
    if (paidChargeMismatchMessage) {
      showFulfillmentShippingBlockAlert(paidChargeMismatchMessage);
      return;
    }

    const mergedOrderInfo = {
      ...orderDetail?.orderInfo,
      ...data.orderInfo,
    };
    const hasInvoice = Boolean(fulfillmentInvoice.invoiceId);
    const invoiceStatusInfo = resolveInvoiceStatusDisplay(fulfillmentInvoice.invoiceStatus, { hasInvoice });
    const shippingChangedForPayload = hasFulfillmentShippingChanged(data);
    const rawInvoiceStatus = fulfillmentInvoice.invoiceStatus;
    const shippingUpdateFields = {
      previousShippingCharge: shippingChangedForPayload ? previousCharge : null,
      invoiceUpdateStatus: shippingChangedForPayload ? invoiceStatusInfo.label : null,
      invoiceId: fulfillmentInvoice.invoiceId,
      invoiceStatus: rawInvoiceStatus,
      updateInvoiceShipping: shouldUpdateInvoiceShipping(
        rawInvoiceStatus,
        shippingChangedForPayload,
        hasInvoice
      ),
    };

    const updateOrderData: OrderFulfillmentInfo = isManualOutsideShipping
      ? {
        ...data,
        ...shippingUpdateFields,
        shippingMethodId: null,
        shippingPrice: fulfillmentShippingPrice,
        orderInfo: {
          ...mergedOrderInfo,
          practice: mergedOrderInfo.practice ?? "",
          facilityAddress: mergedOrderInfo.facilityAddress ?? "",
          processedDate: mergedOrderInfo.processedDate ?? "",
          shippingMethod: data.shippingMethod || "",
          shippingPrice: fulfillmentShippingPrice,
          shipping_charges: fulfillmentShippingPrice,
        },
      }
      : {
        ...data,
        ...shippingUpdateFields,
        shippingPrice: fulfillmentShippingPrice,
        orderInfo: {
          ...mergedOrderInfo,
          practice: mergedOrderInfo.practice ?? "",
          facilityAddress: mergedOrderInfo.facilityAddress ?? "",
          processedDate: mergedOrderInfo.processedDate ?? "",
          shippingMethod: data.shippingMethod || mergedOrderInfo.shippingMethod || "",
          shippingMethodId: data.shippingMethodId ?? mergedOrderInfo.shippingMethodId ?? null,
          shippingPrice: fulfillmentShippingPrice,
          shipping_charges: fulfillmentShippingPrice,
        },
      };

    const response = await dispatch(
      updateOrder({ orderUpdataData: updateOrderData, interceptorOption: { skipErrorPopup: true } })
    );

    console.log(updateOrderData)

    if (
      response.payload &&
      response.payload.code === "V3OK" &&
      response.payload.message === "SUCCESS" &&
      (!response.payload.errors || response.payload.errors.length === 0)
    ) {
      const currentTrackingNumber = getValues("trackingNumber");

      if (currentTrackingNumber) {
        // CS-1766 - Use shippingMethod to derive carrier for webhook registration
        const currentShippingMethod = getValues("shippingMethod");
        const currentTrackingStatus = getValues("orderStatus");
        const previousTrackingNumber = orderDetail?.trackingNumber;
        const previousShippingMethod = originalShippingMethod;
        const previousTrackingStatus = orderDetail?.orderStatus;

        const trackingNumber = currentTrackingNumber;
        const carrier = getCarrierNumber(currentShippingMethod || "");
        const orderId = orderDetail.orderId;

        if (
          currentTrackingNumber !== previousTrackingNumber ||
          currentShippingMethod !== previousShippingMethod
        ) {
          const previousCarrier = getCarrierNumber(previousShippingMethod || orderDetail?.shippingCarrier || "");
          const registrationData: TrackingRegistrationRequest[] = [
            {
              number: getValues("trackingNumber"),
              order_no: getValues("orderNumber"),
              tag: getValues("orderNumber"),
              carrier: getCarrierNumber(getValues("shippingMethod") || ""),
              order_time: moment(response.payload.data.orderDate).format("YYYY/M/D"),
              email: userInfo.userName,
              ...(previousTrackingNumber ? { previous_number: previousTrackingNumber } : {}),
              ...(previousTrackingNumber && previousCarrier ? { previous_carrier: previousCarrier } : {}),
            },
          ];

          const registerResponse = await dispatch(registerWebhookTracking(registrationData));
          if (registerResponse.payload === "SUCCESS") {
            await fetchTrackingInfo(trackingNumber, carrier, orderId);
          }
        } else if (currentTrackingStatus !== previousTrackingStatus) {
          await fetchTrackingInfo(trackingNumber, carrier, orderId);
        }
      }

      let successObj: SingleAlertInfo = {
        message: `Order ${orderNumber} is updated successfully.`,
        alertType: "success",
      };
      dispatch(setSingleAlertObj(successObj));
      navigate("/order_list");
    } else if (response?.payload?.code === RESPONSE_CODES.FAILED_CODE) {
      const alertObj: SingleAlertInfo = {
        message: response.payload?.message,
        alertType: "error",
      };
      dispatch(setSingleAlertObj(alertObj));
    }
  };

  const handleConfirmFullFillOrder = async () => {
    const { formData } = fullFillOrderWarningPopup;

    setFullFillOrderWarningPopup({ show: false, orderIds: [], formData: null });

    if (formData) {
      await executeUpdateOrder(formData);
    }
  };

  const fetchTrackingInfo = async (trackingNumber: string, carrier: number, orderId: number) => {
    dispatch(showHideTrackingLoadingDialog(true));
    try {
      await Promise.all([
        dispatch(getRealTimeTrackInfo({ trackingNumber, carrier, orderId })),
        new Promise(resolve => setTimeout(resolve, 3000))
      ]);
    } finally {
      dispatch(showHideTrackingLoadingDialog(false));
    }
  }

  // CS-1766 - Updated to accept shipping method string and extract carrier for lookup
  const getCarrierNumber = (shippingMethod: string): number => {
    const carrier = extractCarrierFromShippingMethod(shippingMethod);
    const carrierMap: { [key: string]: number } = {
      FEDEX: 100003,
      UPS: 100002,
      DHL: 100001,
      USPS: 21051,
      // Add more carriers if needed
    };
  
    return carrierMap[carrier] || 0; // Default to 0 if the carrier is not found
  };

  // CS-1766 - Handle shipping method change with confirmation popup
  const handleShippingMethodChange = (_: string, value?: string | null) => {
    const selectedShippingMethod = value || "";
    const orderDetailData = location?.state?.selectedOrderDetail as OrderInfo | undefined;
    const appliedShipping = appliedShippingRef.current;

    if (!originalShippingMethod) {
      const matched = findShippingMethodOption(shippingMethodOptions, selectedShippingMethod);
      setValue("shippingMethodId", matched?.shippingConfigId ?? null);
      return;
    }

    if (isSameShippingMethodSelection(selectedShippingMethod, appliedShipping.method)) {
      const matched = findShippingMethodOption(shippingMethodOptions, selectedShippingMethod);
      setValue("shippingMethodId", matched?.shippingConfigId ?? null);
      return;
    }

    if (selectedShippingMethod === originalShippingMethod) {
      const matched = findShippingMethodOption(shippingMethodOptions, selectedShippingMethod);
      setValue("shippingMethodId", matched?.shippingConfigId ?? null);
      setValue("shippingMethod", originalShippingMethod);
      setValue("shippingPrice", originalShippingCharge);
      syncAppliedShipping(originalShippingMethod, originalShippingCharge);
      return;
    }

    const revertShippingMethodSelection = () => {
      setValue("shippingMethod", appliedShipping.method);
      const appliedMatched = findShippingMethodOption(shippingMethodOptions, appliedShipping.method);
      setValue("shippingMethodId", appliedMatched?.shippingConfigId ?? null);
      setValue("shippingPrice", appliedShipping.charge);
    };

    const blockMessage = getFulfillmentShippingBlockMessage(fulfillmentInvoice, true);
    if (blockMessage) {
      revertShippingMethodSelection();
      showFulfillmentShippingBlockAlert(blockMessage);
      return;
    }

    const requestedShipping = resolveOriginalRequestedShippingInfo(orderDetailData);
    const currentShipping = resolveCurrentFulfillmentShippingInfo(orderDetailData, appliedShipping);
    const hasInvoice = Boolean(fulfillmentInvoice.invoiceId);
    const previousCharge = resolvePreviousShippingChargeForFulfillment(orderDetailData, fulfillmentInvoice);
    const newCharge = extractShippingCharge(selectedShippingMethod) ?? 0;
    const invoiceStatusInfo = resolveInvoiceStatusDisplay(fulfillmentInvoice.invoiceStatus, { hasInvoice });
    const isPaidInvoice = invoiceStatusInfo.category === "paid";
    const initialFulfillmentCharge = isPaidInvoice ? previousCharge : newCharge;

    revertShippingMethodSelection();

    setShippingChangePopupData({
      requestedShippingMethod: requestedShipping.method,
      requestedShippingCharge: requestedShipping.charge,
      currentShippingMethod: currentShipping.method,
      currentShippingCharge: currentShipping.charge,
      fulfillmentShippingMethod: selectedShippingMethod,
      initialFulfillmentCharge,
      previousShippingCharge: previousCharge,
      invoiceStatusLabel: invoiceStatusInfo.label,
      invoiceStatusCategory: invoiceStatusInfo.category,
      invoiceStatus: fulfillmentInvoice.invoiceStatus,
    });
    setShowShippingChangePopup(true);
  };

  const handleConfirmShippingChange = (confirmData: {
    fulfillmentShippingMethod: string;
    fulfillmentShippingCharge: number;
  }) => {
    const orderDetailData = location?.state?.selectedOrderDetail as OrderInfo | undefined;
    const previousCharge = resolvePreviousShippingChargeForFulfillment(orderDetailData, fulfillmentInvoice);
    const isPaidInvoice = isPaidInvoiceStatus(fulfillmentInvoice.invoiceStatus);
    const shippingCharge = isPaidInvoice ? previousCharge : confirmData.fulfillmentShippingCharge;

    if (
      isPaidInvoice
      && isPaidInvoiceConfirmBlocked(previousCharge, confirmData.fulfillmentShippingMethod, shippingCharge)
    ) {
      showFulfillmentShippingBlockAlert(PAID_INVOICE_CHARGE_MISMATCH_MESSAGE);
      return;
    }

    setValue("shippingMethod", formatShippingMethodWithCharge(
      confirmData.fulfillmentShippingMethod,
      shippingCharge
    ));
    const matched = findShippingMethodOption(
      shippingMethodOptions,
      confirmData.fulfillmentShippingMethod
    );
    setValue("shippingMethodId", matched?.shippingConfigId ?? null);
    setValue("shippingPrice", shippingCharge);
    syncAppliedShipping(
      formatShippingMethodWithCharge(confirmData.fulfillmentShippingMethod, shippingCharge),
      shippingCharge
    );
    setShowShippingChangePopup(false);
    setShippingChangePopupData(null);
  };

  const handleCancelShippingChange = () => {
    const appliedShipping = appliedShippingRef.current;
    setValue("shippingMethod", appliedShipping.method);
    const matched = findShippingMethodOption(shippingMethodOptions, appliedShipping.method);
    setValue("shippingMethodId", matched?.shippingConfigId ?? null);
    setValue("shippingPrice", appliedShipping.charge);
    setShowShippingChangePopup(false);
    setShippingChangePopupData(null);
  };

  const handleStatusSelectChange = (name: string, value: string) => {
    const ct: CodeTable | undefined = statuses.find(
      (option) => option.keyName === value
    );
    if (ct?.keyName === PRODUCT_STATUS.SHIPPED) {
      setValue("shippedDate", dayjs(getValues("updateStatusDate")).format('MM/DD/YYYY'));
      setValue("deliveredDate", localOrderDetail.deliveredDate || "");
      setValue("processedDate", localOrderDetail.orderInfo?.processedDate || "");
      setValue("orderStatus", ct?.keyName);
    } else if (ct?.keyName === PRODUCT_STATUS.DELIVERED) {
      setValue("deliveredDate", dayjs(getValues("updateStatusDate")).format('MM/DD/YYYY'));
      setValue("shippedDate", localOrderDetail.shippedDate || "");
      setValue("processedDate", localOrderDetail.orderInfo?.processedDate || "");
      setValue("orderStatus", ct?.keyName);
    } else if (ct?.keyName === PRODUCT_STATUS.PROCESSING) {
      setValue("processedDate", dayjs(getValues("updateStatusDate")).format('MM/DD/YYYY'));
      setValue("orderStatus", ct?.keyName);
      setValue("shippedDate", localOrderDetail.shippedDate || "");
      setValue("deliveredDate", localOrderDetail.deliveredDate || "");
    } else {
      setValue("deliveredDate", localOrderDetail.deliveredDate || "");
      setValue("shippedDate", localOrderDetail.shippedDate || "");
      setValue("processedDate", localOrderDetail.orderInfo?.processedDate || "");
      setValue("orderStatus", orderDetail.orderStatus);
    }
  }

  const handleUpdateStatusDateChange = (date: Date | null) => {
    let statusDate: string = dayjs(date).format("MM/DD/YYYY");
    if (getValues("orderStatus") === PRODUCT_STATUS.SHIPPED) {
      setValue("shippedDate", statusDate);
      setValue("deliveredDate", localOrderDetail.deliveredDate || "");
      setValue("processedDate", localOrderDetail.orderInfo?.processedDate || "");
    } else if (getValues("orderStatus") === PRODUCT_STATUS.DELIVERED) {
      setValue("deliveredDate", statusDate);
      setValue("shippedDate", localOrderDetail.shippedDate || "");
      setValue("processedDate", localOrderDetail.orderInfo?.processedDate || "");
    } else if (getValues("orderStatus") === PRODUCT_STATUS.PROCESSING) {
      setValue("processedDate", statusDate);
      setValue("deliveredDate", localOrderDetail.deliveredDate || "");
      setValue("shippedDate", localOrderDetail.shippedDate || "");
    } else {
      setValue("deliveredDate", localOrderDetail.deliveredDate || "");
      setValue("shippedDate", localOrderDetail.shippedDate || "");
      setValue("processedDate", localOrderDetail.orderInfo?.processedDate || "");
    }
  }

  const renderMFRPatientIDTextfieldComponent = (manufacturerPatientId: string) => {
    if (isEditing) {
      return (
        <Box sx={inputFieldSx()}>
          <CustomTextField
            controllerName="manufacturerPatientId"
            autoFocus
            control={control}
            label=""
            size="small"
            value={manufacturerPatientId}
            onChange={(event) => {
              const inputData = event.target.value;
              setMFRPatientId((prev: any) => ({
                ...prev,
                manufacturerPatientId: inputData
              }));
            }}
            onBlur={() => {
              setIsEditing(false);
              const newValue = getValues("manufacturerPatientId");
              const originalValue = mfrPatientIDinPatientInfo;

              if (newValue && newValue !== originalValue) {
                setShowUpdateMFRPatientIdPopup({
                  show: true,
                  message: `Do you want to update the current Manufacturer Patient ID ${originalValue ? `from ${originalValue}` : ''} to ${newValue}?`,
                  variant: "confirm",
                  title: "Update Manufacturer Patient ID",
                  buttons: [
                    {
                      name: "Yes",
                      color: "success",
                      onClick: () => {
                        setValue("manufacturerPatientId", newValue);
                        setLocalOrderDetail(prev => ({
                          ...prev,
                          manufacturerPatientId: newValue
                        }));
                        setShowUpdateMFRPatientIdPopup(prev => ({ ...prev, show: false }));
                      }
                    },
                    {
                      name: "No",
                      color: "error",
                      onClick: () => {
                        setValue("manufacturerPatientId", originalValue);
                        setMFRPatientId((prev: any) => ({
                          ...prev,
                          manufacturerPatientId: originalValue || ""
                        }));
                        setShowUpdateMFRPatientIdPopup((prev: any) => ({ ...prev, show: false }));
                      }
                    }
                  ]
                });
              }
            }}
            name="manufacturerPatientId"
          />
        </Box>
      );
    }
    return mfrPatientId.manufacturerPatientId || orderDetail.manufacturerPatientId;
  };

  const FieldLabel = ({ label, required = false }: { label: string; required?: boolean }) => (
    <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: mTokens.textSecondary, mb: 0.7, display: "flex", alignItems: "center", gap: 0.4 }}>
      {label}{required && <Box component="span" sx={{ color: mTokens.accent }}>*</Box>}
    </Typography>
  );

  const InfoRow = ({ label, value }: { label: string; value?: ReactNode }) => (
    <Box display="flex" alignItems="center" py={0.8} sx={{ borderBottom: `1px solid ${mTokens.border}`, "&:last-child": { borderBottom: "none" } }}>
      <Typography sx={{ fontSize: "0.82rem", color: mTokens.textSecondary, width: "45%", flexShrink: 0 }}>
        {label}
      </Typography>
      <Typography sx={{ fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 600, flex: 1 }} component="div">
        {value ?? "—"}
      </Typography>
    </Box>
  );

  const colHeaderSx = {
    fontSize: "0.68rem",
    fontWeight: 700,
    color: mTokens.accent,
    textTransform: "uppercase" as const,
    letterSpacing: "0.08em",
  };
  const colBodySx = { fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 500 };

  useEffect(() => {
    setMFRPatientId({
      patientId: orderDetail.patientId,
      manufacturerPatientId: getValues("manufacturerPatientId")
    });

    if (!orderDetail.manufacturerPatientId) {
      setIsEditing(true);
    }
  }, [getValues, orderDetail.manufacturerPatientId, orderDetail.patientId]);

  return (
    <Box
      sx={{
        mx: { xs: "10px", sm: "20px" },
        mt: "12px",
        pb: "72px",
      }}
    >
      {/* CS-1766 - Shipping method change confirmation popup */}
      {showShippingChangePopup && shippingChangePopupData && (
        <ShippingMethodChangePopup
          open={showShippingChangePopup}
          requestedShippingMethod={shippingChangePopupData.requestedShippingMethod}
          requestedShippingCharge={shippingChangePopupData.requestedShippingCharge}
          currentShippingMethod={shippingChangePopupData.currentShippingMethod}
          currentShippingCharge={shippingChangePopupData.currentShippingCharge}
          fulfillmentShippingMethod={shippingChangePopupData.fulfillmentShippingMethod}
          initialFulfillmentCharge={shippingChangePopupData.initialFulfillmentCharge}
          previousShippingCharge={shippingChangePopupData.previousShippingCharge}
          invoiceStatusLabel={shippingChangePopupData.invoiceStatusLabel}
          invoiceStatusCategory={shippingChangePopupData.invoiceStatusCategory}
          invoiceStatus={shippingChangePopupData.invoiceStatus}
          allowFreeShipping={allowFreeShipping}
          onClose={handleCancelShippingChange}
          onConfirm={handleConfirmShippingChange}
        />
      )}
      {/* MFR Patient ID update popup */}
      {showUpdateMFRPatientIdPopup.show && (
        <OptionsPopup
          open={showUpdateMFRPatientIdPopup.show}
          onClose={() => setShowUpdateMFRPatientIdPopup(prev => ({ ...prev, show: false }))}
          variant={showUpdateMFRPatientIdPopup.variant}
          message={<>{showUpdateMFRPatientIdPopup.message}</>}
          buttons={showUpdateMFRPatientIdPopup.buttons}
          title={showUpdateMFRPatientIdPopup.title}
        />
      )}
      {fullFillOrderWarningPopup.show && (
        <TrackingWarningPopup
          open={fullFillOrderWarningPopup.show}
          orderIds={fullFillOrderWarningPopup.orderIds}
          onClose={() => setFullFillOrderWarningPopup({ show: false, orderIds: [], formData: null })}
          onConfirm={handleConfirmFullFillOrder}
        />
      )}

      <Box mb={1.5} display="flex" alignItems="flex-start" gap={1.5}>
        <PageBackButton tooltip={null} />
        <Box data-testid="header">
          <Typography sx={{ fontSize: "0.7rem", fontWeight: 700, color: mTokens.textSecondary, textTransform: "uppercase", letterSpacing: "0.12em", mb: 0.3 }}>
            Orders / Update Order
          </Typography>
          <Typography sx={{ fontSize: "1.6rem", fontWeight: 800, color: mTokens.textPrimary, lineHeight: 1.1 }}>
            Update Order
          </Typography>
          <Typography sx={{ fontSize: "0.78rem", color: mTokens.textSecondary, mt: 0.4 }}>
            Update the order details below.
          </Typography>
        </Box>
      </Box>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "2fr 1fr" }, gap: 1.5, alignItems: "flex-start" }}>
          <Box sx={{ ...cardSx, order: { xs: 2, md: 1 } }}>
            <SectionHeader icon={<Inventory2Outlined fontSize="small" />} title="Ordered Items" />
            <Box sx={{ px: 2.8, pt: 1.5, pb: 2.8 }}>
              {/* CS-1103 */}
              {isAncillary ? (
                <Box sx={{ mb: 2.5, border: `1px solid ${mTokens.border}`, borderRadius: "12px", overflow: "hidden" }}>
                  <Box sx={{ display: "grid", gridTemplateColumns: "3fr 1fr", gap: 1, px: 2, py: 0.8, backgroundColor: mTokens.headerFooterBg, borderBottom: `1px solid ${mTokens.border}` }}>
                    <Typography sx={colHeaderSx}>Product Name</Typography>
                    <Typography sx={colHeaderSx}>Quantity</Typography>
                  </Box>
                  {fields?.map((field, index) => (
                    <Box
                      key={field.id}
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "3fr 1fr",
                        gap: 1,
                        px: 2,
                        py: 1.1,
                        borderBottom: index < fields.length - 1 ? `1px dashed ${mTokens.border}` : "none",
                        alignItems: "center",
                      }}
                    >
                      <Typography sx={colBodySx}>{field.productItemDescription}</Typography>
                      <Typography sx={colBodySx}>{field.quantity}</Typography>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Box sx={{ mb: 2.5, border: `1px solid ${mTokens.border}`, borderRadius: "12px", overflow: "hidden" }}>
                  <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 2fr" }, gap: 1, px: 2, py: 0.8, backgroundColor: mTokens.headerFooterBg, borderBottom: `1px solid ${mTokens.border}` }}>
                    <Typography sx={colHeaderSx}>Ordered Size</Typography>
                    <Typography sx={{ ...colHeaderSx, display: { xs: "none", sm: "block" } }}>Serial Number</Typography>
                  </Box>
                  {fields?.map((field, index) => (
                    <Box
                      key={field.id}
                      sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", sm: "1fr 2fr" },
                        gap: 1,
                        px: 2,
                        py: 1.1,
                        borderBottom: index < fields.length - 1 ? `1px dashed ${mTokens.border}` : "none",
                        alignItems: "center",
                      }}
                    >
                      <Typography sx={{ ...colBodySx, color: mTokens.accent, fontWeight: 700 }}>{field.size}</Typography>
                      <Box sx={inputFieldSx()}>
                        <CustomTextField
                          controllerName={`orderItems.${index}.serialNumber`}
                          control={control}
                          label=""
                          size="small"
                          placeholder="Enter serial number"
                          rules={{
                            maxLength: { value: 50, message: "Serial Number cannot exceed 50 characters" },
                          }}
                        />
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}

              <Grid container spacing={2}>
                {/* CS-1766 - Product-specific shipping method dropdown */}
                {isManualOutsideShipping ? (
                  <>
                    <Grid item xs={12} md={6}>
                      <FieldLabel label="Shipping Method" />
                      <Box sx={inputFieldSx()}>
                        <CustomTextField
                          controllerName="shippingMethod"
                          control={control}
                          label=""
                          size="small"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FieldLabel label="Shipping Charge" />
                      <Box sx={inputFieldSx()}>
                        <CustomCurrencyField
                          controllerName="shippingPrice"
                          control={control}
                          label=""
                          size="small"
                          InputProps={{ startAdornment: <Typography sx={{ mr: 0.5, color: mTokens.textSecondary }}>$</Typography> }}
                        />
                      </Box>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12} md={6}>
                    <FieldLabel label="Shipping Method" />
                    <Box sx={dropdownWrapSx()}>
                        <CustomDropdownField
                        name="shippingMethod"
                        control={control}
                        options={fulfillmentShippingMethodOptions}
                        label=""
                        size="small"
                        sortOptions={false}
                        onChangeSelect={handleShippingMethodChange}
                      />
                    </Box>
                  </Grid>
                )}
                <Grid item xs={12} md={6}>
                  <FieldLabel label="Shipping Tracking #" />
                  <Box
                    sx={trackingFieldWrapSx}
                    data-testid="tracking-number-field"
                    data-tracking-status={trackingFormatFeedback.status}
                  >
                    <CustomTextField
                      controllerName="trackingNumber"
                      label=""
                      size="small"
                      control={control}
                      placeholder="Enter tracking number"
                      rules={trackingNumberRules}
                      helperText={trackingFormatFeedback.message ?? undefined}
                      color={
                        trackingFormatFeedback.status === "valid"
                          ? "success"
                          : trackingFormatFeedback.status === "invalid"
                            ? "error"
                            : undefined
                      }
                      InputProps={{
                        endAdornment:
                          trackingFormatFeedback.status === "idle" ? undefined : (
                            <InputAdornment position="end">
                              {trackingFormatFeedback.status === "valid" ? (
                                <CheckCircleOutline
                                  data-testid="tracking-number-verified-icon"
                                  sx={{ color: "#22c55e", fontSize: 18 }}
                                />
                              ) : (
                                <ErrorOutline
                                  data-testid="tracking-number-error-icon"
                                  sx={{ color: mTokens.error, fontSize: 18 }}
                                />
                              )}
                            </InputAdornment>
                          ),
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FieldLabel label="Update Status to" required />
                  <Box sx={dropdownWrapSx(!!errors.orderStatus)}>
                    <CustomDropdownField
                      name="orderStatus"
                      control={control}
                      options={updateStatuses}
                      label=""
                      size="small"
                      onChangeSelect={handleStatusSelectChange}
                      rules={{ required: "Update Status is required." }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FieldLabel label={updateStatusDateLabelText} required />
                  <Box sx={datepickerWrapSx(!!errors.updateStatusDate)}>
                    <CustomDatePicker
                      key={`update-status-date-${orderStatusValue || "default"}-${updateStatusDateLabelText}`}
                      control={control}
                      controllerName="updateStatusDate"
                      label=""
                      size="small"
                      onChange={handleUpdateStatusDateChange}
                      rules={updateStatusDateRules}
                    />
                  </Box>
                </Grid>
              </Grid>

              {/* CS-1426 - Start */}
              <Box
                display="flex"
                justifyContent={{ xs: "stretch", sm: "flex-end" }}
                flexDirection={{ xs: "column", sm: "row" }}
                gap={1.2}
                mt={2.5}
              >
                <Button
                  type="submit"
                  startIcon={<ClassOutlined />}
                  variant="contained"
                  removeUpperCase
                  sx={{
                    ...primaryBtnSx,
                    minWidth: { sm: 140 },
                    backgroundColor: mTokens.accent,
                    boxShadow: "0 4px 18px rgba(20,184,166,.35)",
                    "& .MuiTypography-root": { color: "#ffffff !important" },
                    "& .MuiButton-startIcon": { color: "#ffffff" },
                  }}
                >
                  Submit
                </Button>
                <Button
                  color="error"
                  variant="outlined"
                  removeUpperCase
                  startIcon={<CancelOutlined />}
                  onClick={() => navigate(-1)}
                  sx={{
                    ...cancelBtnSx,
                    minWidth: { sm: 140 },
                    "& .MuiTypography-root": { color: `${mTokens.error} !important` },
                    "& .MuiButton-startIcon": { color: mTokens.error },
                  }}
                >
                  Cancel
                </Button>
              </Box>
              {/* CS-1426 - End */}
            </Box>
          </Box>

          <Box sx={{ ...cardSx, order: { xs: 1, md: 2 } }}>
            <SectionHeader icon={<PersonOutlined fontSize="small" />} title="Info" />
            <Box sx={{ px: 2.8, py: 1.5 }}>
              <InfoRow label="Patient" value={getValues("patientName") || orderDetail?.orderInfo?.patient} />
              <Box display="flex" alignItems="center" py={0.8} sx={{ borderBottom: `1px solid ${mTokens.border}` }}>
                <Typography sx={{ fontSize: "0.82rem", color: mTokens.textSecondary, width: "45%", flexShrink: 0 }}>
                  Manufacturer Patient ID #
                </Typography>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  {getValues("manufacturerPatientId") ? (
                    <Box display="flex" alignItems="center">
                      {isEditing ? (
                        renderMFRPatientIDTextfieldComponent(getValues("manufacturerPatientId"))
                      ) : (
                        <Tooltip title="Click to edit" placement="top" arrow>
                          <Typography
                            component="span"
                            onClick={() => setIsEditing(true)}
                            sx={{
                              cursor: "pointer",
                              fontWeight: 600,
                              fontSize: "0.88rem",
                              color: "#38bdf8",
                              "&:hover": { textDecoration: "underline" },
                            }}
                          >
                            {getValues("manufacturerPatientId")}
                          </Typography>
                        </Tooltip>
                      )}
                    </Box>
                  ) : (
                    <Box sx={inputFieldSx()}>
                      <CustomTextField
                        controllerName="manufacturerPatientId"
                        control={control}
                        label=""
                        size="small"
                        autoFocus={isEditing}
                        onBlur={() => setIsEditing(false)}
                      />
                    </Box>
                  )}
                </Box>
              </Box>
              <Box py={0.8} sx={{ borderBottom: `1px solid ${mTokens.border}` }}>
                <FieldLabel label="Manufacturer Order ID #" />
                <Box sx={inputFieldSx()}>
                  <CustomTextField
                    controllerName="manufacturerOrderId"
                    label=""
                    size="small"
                    control={control}
                  />
                </Box>
              </Box>
              <InfoRow label="Product" value={<>{getValues("productName")} ({getValues("manufacturerName")})</>} />
              <InfoRow label="Order ID" value={getValues("orderNumber")} />
              <InfoRow label="PO #" value={getValues("poNumber") || "—"} />
            </Box>
          </Box>
        </Box>
      </form>
    </Box>
  );
};

export default OrderFulfillment;
